import { z } from 'zod';

const schema = z.object({
  VITE_API_BASE_URL: z.string().trim().default('/api/v1'),
});

export const environment = schema.parse(import.meta.env);
